import { IParentOrganizationTree } from "./../../interfaces/parentOrganizationTree";
import { ITankProfile } from "src/app/interfaces/tankProfile";
import {
  selectParentOrganizationTree,
  selectUserInformation,
} from "./../../state/selectors/user-profile.selectors";
import { Store } from "@ngrx/store";
import { Injectable } from "@angular/core";
import { AppState } from "src/app/app.state";
import { firstValueFrom } from "rxjs";
import { IUserInformation } from "src/app/interfaces/userInformation";
import { selectLastSelectedTankProfile } from "src/app/state/selectors/tank-profile.selectors";

@Injectable()
export class ChartingService {
  constructor(private store: Store<AppState>) {}

  async GetPopUpChartSubheaderModel(): Promise<any> {
    const userInfo: IUserInformation = await firstValueFrom(
      this.store.select(selectUserInformation)
    );
    const tankProfile: ITankProfile = await firstValueFrom(
      this.store.select(selectLastSelectedTankProfile)
    );
    const orgTree: IParentOrganizationTree[] = await firstValueFrom(
      this.store.select(selectParentOrganizationTree)
    );

    let rootOrgName = "";
    let childOrgName = "";
    if (orgTree && orgTree.length > 0) {
      let orgTreeSorted = [...orgTree].sort(
        (a, b) => a.parentLevel - b.parentLevel
      );
      rootOrgName = orgTreeSorted[0].organizationName;
      if (orgTree.length > 1) {
        childOrgName = orgTreeSorted[orgTree.length - 1].organizationName;
      }
    }

    return {
      userName: userInfo.userName,
      profileName: tankProfile.tankProfileName,
      orgName: rootOrgName,
      childOrgName: childOrgName,
    };
  }
}
